import * as React from 'react'
import Link from 'next/link'
import styled from 'styled-components'

import { CheckboxField } from '../form/fields/CheckboxField'
import * as icons from '../../svg/icons'
import * as S from '../../styles'
import { FiltersType } from '../../hooks/useFilterList'

export const MAX_LIST_LENGTH = 15
export type OnSelectionChange = (value: string, isSelected: boolean) => void
export type OnToggle = (open: boolean) => void

type ContentListType = {
  filters: FiltersType[]
  onSelectionChange: OnSelectionChange
  onToggle: OnToggle
  setShouldShowAll: React.Dispatch<React.SetStateAction<boolean>>
  shouldShowAll: boolean
  title: React.ReactNode
}

export function ContentList({
  filters,
  onSelectionChange,
  onToggle,
  setShouldShowAll,
  shouldShowAll,
  title,
}: ContentListType): React.ReactElement {
  const visibleFilters = shouldShowAll ? filters : filters.slice(0, MAX_LIST_LENGTH)

  return (
    <S.filter.ContentListWrapper>
      <S.filter.Back
        onClick={() => {
          setShouldShowAll(filters.length <= MAX_LIST_LENGTH)
          onToggle(false)
        }}
      >
        <icons.ChevronLeft size={20} /> <S.copy.Text5>{title}</S.copy.Text5>
      </S.filter.Back>

      <S.filter.List>
        {visibleFilters.map((filter) => {
          return (
            <CheckboxField
              key={filter.id}
              checked={filter.isSelected}
              label={filter.name}
              onChange={() => {
                onSelectionChange(filter.id, !filter.isSelected)
              }}
            />
          )
        })}
      </S.filter.List>
      {!shouldShowAll && (
        <StyledLink
          as="button"
          onClick={() => {
            setShouldShowAll(true)
          }}
        >
          + voir plus
        </StyledLink>
      )}
    </S.filter.ContentListWrapper>
  )
}

const StyledLink = styled(Link)`
  border: 0px solid transparent;
  padding-left: 25px;
  margin-top: 15px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:focus,
  &:hover,
  &:active {
    outline: none;
  }
`
